import Vue from 'vue'
import Clipboard from 'clipboard'

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
    }

    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update() {

  },
  unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
})
Vue.directive('clipboard', {
  bind(el, binding) {
    if (binding.arg === 'success') {
      el._v_clipboard_success = binding.value
    } else if (binding.arg === 'error') {
      el._v_clipboard_error = binding.value
    } else {
      const clipboard = new Clipboard(el, {
        text() {
          return binding.value
        },
        action() {
          return binding.arg === 'cut' ? 'cut' : 'copy'
        }
      })
      clipboard.on('success', e => {
        const callback = el._v_clipboard_success
        callback && callback(e) // eslint-disable-line
      })
      clipboard.on('error', e => {
        const callback = el._v_clipboard_error
        callback && callback(e) // eslint-disable-line
      })
      el._v_clipboard = clipboard
    }
  },
  update(el, binding) {
    if (binding.arg === 'success') {
      el._v_clipboard_success = binding.value
    } else if (binding.arg === 'error') {
      el._v_clipboard_error = binding.value
    } else {
      el._v_clipboard.text = function () {
        return binding.value
      }
      el._v_clipboard.action = function () {
        return binding.arg === 'cut' ? 'cut' : 'copy'
      }
    }
  },
  unbind(el, binding) {
    if (binding.arg === 'success') {
      delete el._v_clipboard_success
    } else if (binding.arg === 'error') {
      delete el._v_clipboard_error
    } else {
      el._v_clipboard.destroy()
      delete el._v_clipboard
    }
  }
})
Vue.directive('doubleCopy', {
  bind(el, binding, VNode) {
    function selectText() {
      if (document.body.createTextRange) {
        var range = document.body.createTextRange();
        range.moveToElementText(el);
        range.select();
      } else if (window.getSelection) {
        var selection = window.getSelection();
        var range = document.createRange();
        range.selectNodeContents(el);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    function copySuccess() {
      el.style.position = "relative";
      var newNode = document.createElement("i");
      newNode.setAttribute("class","iconfont");
      newNode.style.position = "absolute";
      newNode.style.right = "-60px";
      newNode.classList.add("icon-dagou","colorBB","size12");
      newNode.innerText = " 已复制";
      el.appendChild(newNode);
      setTimeout(()=>{
        newNode.remove();
      },1200)
    }
    function copyText() {
      selectText();
      document.execCommand("Copy");
      copySuccess();
    }
    el.doubleCopy = copyText;
    el.addEventListener('dblclick', copyText);
  },
  unbind(el) {
    el.removeEventListener('dblclick', el.doubleCopy);
    delete el.doubleCopy;
  }
})
export default {}



// WEBPACK FOOTER //
// ./src/public/directive.js